// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-m_gR","advertDetailServiceList__header":"c-m_gS","advertDetailServiceList__list":"c-m_gT"};